// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import http from './assets/js/url.js'
import Global from './assets/js/Global'

import wx from 'weixin-js-sdk';

Vue.config.productionTip = false
Vue.prototype.$http = http
Vue.prototype.$Global = Global
Vue.prototype.$wx = wx

Vue.prototype.back = function (route) {
  if (window.history.length > 1) {
    this.$router.back();
  } else {
    this.$router.replace(route);
  }
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js